import { render, staticRenderFns } from "./HumanBodyBackMuscles.vue?vue&type=template&id=340c3168"
import script from "./HumanBodyBackMuscles.vue?vue&type=script&lang=js"
export * from "./HumanBodyBackMuscles.vue?vue&type=script&lang=js"
import style0 from "./HumanBodyBackMuscles.vue?vue&type=style&index=0&id=340c3168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports